import firebase from 'firebase'

export const initializeFirebase = () => {

    firebase.initializeApp({
        apiKey: "AIzaSyCk1pwE3rHyILqjkNKs6kAIhvtPly-xRa4",
        authDomain: "marcel-228809.firebaseapp.com",
        databaseURL: "https://marcel-228809.firebaseio.com",
        projectId: "marcel-228809",
        storageBucket: "marcel-228809.appspot.com",
        messagingSenderId: "1072397277719",
        appId: "1:1072397277719:web:8dd85fad7b70a09bdc5a52"
    });

};





// WEBPACK FOOTER //
// ./src/firebase.js